module.exports = __webpack_public_path__ + "static/6-insights-8bfcbb9ac9922332c4eedf7f29b67026.jpg";